// Built @Wed, 27 Dec 2023 03:56:16 GMT
import { createClass as _createClass, classCallCheck as _classCallCheck } from "./_virtual/_rollupPluginBabelHelpers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { log } from "./utils/util.js";
var TAG = "ProgressInfo";
function getBuffers(buffered) {
  var buffers = [];
  if (!buffered || buffered.length < 1) {
    return buffers;
  }
  for (var i = 0; i < buffered.length; i++) {
    var start = parseInt(buffered.start(i) * 1e3, 10) / 1e3;
    var end = parseInt(buffered.end(i) * 1e3, 10) / 1e3;
    buffers.push({
      start,
      end
    });
  }
  return buffers;
}
function getDiff(end, start) {
  return parseInt(end * 1e3 - start * 1e3, 10) / 1e3;
}
function getDuration(played) {
  var t = 0;
  for (var i = 0; i < played.length; i++) {
    var item = played[i];
    if (item.end < 0) {
      continue;
    }
    t += item.end - item.start;
  }
  return t;
}
var ProgressInfo = /* @__PURE__ */ function() {
  function ProgressInfo2() {
    _classCallCheck(this, ProgressInfo2);
    this._init();
  }
  _createClass(ProgressInfo2, [{
    key: "_init",
    value: function _init() {
      this.played = [];
      this.playedSize = 0;
      this.cachedSize = 0;
      this.pcdnCached = 0;
      this.cachedVideoSize = 0;
      this.pcdnVideoCached = 0;
      this.file = {
        audio: 0,
        video: 0
      };
      this.lastBitrate = null;
      this.curBitrate = {
        vBitrate: 0,
        aBitrate: 0,
        cdnSize: 0,
        pcdnSize: 0,
        definition: "",
        fileid: ""
      };
      this.nextBitrate = {
        start: -1
      };
      this.currentTime = 0;
      this.buffered = [];
      this.cachedTime = 0;
      this.duration = 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._init();
    }
  }, {
    key: "getFileSize",
    value: function getFileSize(duration) {
      var _this$curBitrate = this.curBitrate, vBitrate = _this$curBitrate.vBitrate, aBitrate = _this$curBitrate.aBitrate;
      return {
        audio: Math.round(duration * aBitrate / 8),
        video: Math.round(duration * vBitrate / 8),
        total: Math.round(duration * (vBitrate + aBitrate) / 8)
      };
    }
    /**
     * @description 添加play阶段性数据
     * @param {*} currentTime
     * @param {*} type  0 - 新增一条数据 1-更新数据
     */
  }, {
    key: "updatePlayed",
    value: function updatePlayed(currentTime) {
      var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      var played = this.played;
      var _len = played.length;
      if (type === 0 || _len < 1) {
        var ls = _len > 0 ? played[_len - 1] : null;
        var _this$curBitrate2 = this.curBitrate, vBitrate = _this$curBitrate2.vBitrate, aBitrate = _this$curBitrate2.aBitrate;
        if (ls && (ls.end < 0 || ls.end - ls.start < 1)) {
          if (ls.end < 0) {
            ls.start = currentTime;
          } else {
            ls.end = currentTime;
          }
          ls.vBitrate = vBitrate;
          ls.aBitrate = aBitrate;
        } else {
          played.push({
            start: currentTime,
            end: -1,
            vBitrate,
            aBitrate
          });
        }
      } else {
        played[_len - 1].end = currentTime;
      }
    }
  }, {
    key: "calculatePlaySize",
    value: function calculatePlaySize() {
      var played = this.played, curBitrate = this.curBitrate;
      var d = getDuration(played);
      var _size = Math.round((curBitrate.aBitrate + curBitrate.vBitrate) * d / 8);
      this.playedSize += _size;
      log(TAG, "calculatePlaySize", "duration: ".concat(d, " playedSize:").concat(this.playedSize), this.played);
      this.played = [];
      return this.playedSize;
    }
  }, {
    key: "copyBitrateInfo",
    value: function copyBitrateInfo(src, dist) {
      ["aBitrate", "vBitrate", "definition", "fileid", "cdnSize", "pcdnSize"].forEach(function(key) {
        src[key] && (dist[key] = src[key]);
      });
      dist.cdnSize = src.cdnSize;
      dist.pcdnSize = src.pcdnSize;
      return dist;
    }
  }, {
    key: "checkNextBitrate",
    value: function checkNextBitrate(currentTime) {
      var nextBitrate = this.nextBitrate;
      if (nextBitrate.start > -1 && currentTime >= nextBitrate.start) {
        var curBitrate = this.curBitrate;
        this.calculatePlaySize();
        log(TAG, "checkNextBitrate", currentTime, nextBitrate.start, this.cachedSize);
        this.copyBitrateInfo(nextBitrate, curBitrate);
        this.updatePlayed(currentTime, 0);
        nextBitrate.start = -1;
        nextBitrate.fileid = "";
        ["vBitrate", "aBitrate", "cdnSize", "pcdnSize"].forEach(function(key) {
          nextBitrate[key] = 0;
        });
      }
    }
  }, {
    key: "updateLastDefInfo",
    value: function updateLastDefInfo() {
      var curBitrate = this.curBitrate;
      if (curBitrate.vBitrate > 0) {
        var lastB = {};
        this.copyBitrateInfo(curBitrate, lastB);
        this.lastBitrate = lastB;
      }
    }
    /**
     * @description 更新码率信息
     * @param {*} info
     */
  }, {
    key: "updateDefInfo",
    value: function updateDefInfo(data, currentTime) {
      log(TAG, "updateDefInfo", currentTime, this.curBitrate.vBitrate, data);
      var mediaType = data.mediaType, start = data.start, bitrate = data.bitrate, definition = data.definition, fileid = data.fileid;
      var upObj = {
        cdnSize: 0,
        pcdnSize: 0
      };
      if (mediaType === "audio") {
        upObj.aBitrate = bitrate;
      } else {
        upObj.vBitrate = bitrate;
        upObj.definition = definition;
        upObj.fileid = fileid;
        this.updateLastDefInfo();
      }
      upObj.start = start;
      this.nextBitrate = upObj;
      this.checkNextBitrate(currentTime);
    }
  }, {
    key: "upDateDownload",
    value: function upDateDownload(data) {
      var cdn_size = data.cdn_size, pcdn_size = data.pcdn_size, mediaType = data.mediaType;
      var curBitrate = this.curBitrate, nextBitrate = this.nextBitrate;
      var type = 0;
      var size = 0;
      if (pcdn_size) {
        type = 1;
        size = pcdn_size;
      } else if (cdn_size) {
        size = cdn_size;
      }
      this.cachedSize += size;
      if (mediaType === "video") {
        this.cachedVideoSize += size;
        type > 0 ? this.pcdnVideoCached += size : "";
      }
      type > 0 ? this.pcdnCached += size : "";
      var needUpdate = nextBitrate.start >= 0 ? nextBitrate : curBitrate;
      needUpdate.cdnSize += size;
      type > 0 ? needUpdate.pcdnSize += size : "";
    }
  }, {
    key: "updateBuffered",
    value: function updateBuffered(buffered) {
      var buffers = getBuffers(buffered);
      var cachedTime = 0;
      buffers.forEach(function(item) {
        cachedTime += getDiff(item.end, item.start);
      });
      this.buffered = buffers;
      this.cachedTime = cachedTime;
    }
  }, {
    key: "isDefInfoFirstChange",
    value: function isDefInfoFirstChange() {
      return !(this.curBitrate && this.curBitrate.vBitrate > 0);
    }
  }]);
  return ProgressInfo2;
}();
export {
  ProgressInfo as default
};
